// assets/mega-menu.js
(function () {
  function setActive(container, linkEl) {
    const img = container.querySelector('[data-mega-preview]');
    const caption = container.querySelector('[data-mega-caption]');
    if (!img || !linkEl) return;

    const src = linkEl.getAttribute('data-mega-image');
    const alt = linkEl.getAttribute('data-mega-alt') || linkEl.textContent.trim();
    const label = linkEl.getAttribute('data-mega-label') || linkEl.textContent.trim();

    if (src) {
      img.src = src;
      img.alt = alt;
    }
    if (caption) caption.textContent = label;

    container.querySelectorAll('.mega-menu__link.is-active').forEach((a) => a.classList.remove('is-active'));
    linkEl.classList.add('is-active');
  }

  function initMega(container) {
    const first = container.querySelector('.mega-menu__link[data-mega-image]');
    if (first) setActive(container, first);

    container.addEventListener(
      'mouseenter',
      (e) => {
        const a = e.target.closest('.mega-menu__link');
        if (!a || !container.contains(a)) return;
        if (a.hasAttribute('data-mega-image')) setActive(container, a);
      },
      true
    );

    container.addEventListener('focusin', (e) => {
      const a = e.target.closest('.mega-menu__link');
      if (!a || !container.contains(a)) return;
      if (a.hasAttribute('data-mega-image')) setActive(container, a);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-mega-menu]').forEach(initMega);
  });
})();
